module.exports = __webpack_public_path__ + "static/media/icon_3.392d7483.svg";